import React from 'react';
import { useTranslation } from 'react-i18next';

import { ITypographySizes } from 'components/Typography/Text';
import { appReactMemo } from 'hocs';

import { ButtonContainer, Container, StyledIcon, Subtitle, Title } from './styled';

export interface INoItemsFoundProps {
  button?: React.ReactElement;
  className?: string;
  icon?: React.ReactElement;
  subtitle?: string;
  subtitleSize?: ITypographySizes;
  title?: string;
  titleSize?: ITypographySizes;
  width?: number;
}

const NoItemsFound: React.FC<INoItemsFoundProps> = ({
  button,
  className,
  icon,
  subtitle,
  subtitleSize = 'sm',
  title,
  titleSize = 'xxl',
  width,
}) => {
  const { t } = useTranslation();

  return (
    <Container className={className}>
      {icon || <StyledIcon width={width} />}
      <Title size={titleSize} variant='regular'>
        {title || t('common.nothingFound')}
      </Title>
      {subtitle && (
        <Subtitle size={subtitleSize} variant='regular'>
          {subtitle}
        </Subtitle>
      )}
      {button && <ButtonContainer>{button}</ButtonContainer>}
    </Container>
  );
};

export default appReactMemo(NoItemsFound);
